$(document).on('change', '.js-submit-on-change', function(e) {
  $(this).closest('form').submit();
});
